/**
 * Проверяет, что широта и долгота являются валидными числами.
 * @param {*} lat - Широта.
 * @param {*} lon - Долгота.
 * @returns {boolean} true, если обе координаты валидны.
 */
const isValidCoordinates = (lat, lon) => (
  !Number.isNaN(parseFloat(lat)) && !Number.isNaN(parseFloat(lon))
);

export default isValidCoordinates;
